<div class="flex gap-2 !h-7">
  @if (!loading()) {
    <div
      class="platform-feature-button"
      [class.selected]="selectedChannels().size === 0"
      (click)="onChannelClick(null)"
    >
      <p>{{ 'pages.campaignDetails.filter.allPlatforms' | translate }}</p>
    </div>

    @for (channel of channelsOrdered().slice(0, 4); track getChannelTracking(channel)) {
      <div
        class="platform-feature-button"
        [class.selected]="selectedChannels().has(channel)"
        (click)="onChannelClick(channel)"
      >
        <app-social-badge backgroundColor="transparent" [size]="16" [iconSize]="16" [type]="channel.platform" />
        <p>{{ channel.platformCreatorId }}</p>
      </div>
    }

    @if (channelsOrdered().length > 4) {
      <div class="platform-feature-button" [class.selected]="moreChannelsSelected()" [matMenuTriggerFor]="channelsMenu">
        <app-icon src="/icons/dots.svg" [size]="16" />
      </div>

      <mat-menu #channelsMenu="matMenu">
        @for (channel of channelsOrdered().slice(4); track getChannelTracking(channel); let last = $last) {
          <button mat-menu-item class="!min-h-7 !h-7" (click)="onChannelClick(channel, $event)">
            <div class="flex items-center justify-between w-full gap-2">
              <div class="flex items-center gap-2">
                <app-social-badge backgroundColor="transparent" [size]="16" [iconSize]="16" [type]="channel.platform" />
                <p class="platform-feature-button-label">
                  {{ channel.platformCreatorId }}
                </p>
              </div>

              <app-icon
                class="w-4 h-4"
                [src]="selectedChannels().has(channel) ? 'icons/circle-check.svg' : 'icons/circle.svg'"
                [color]="selectedChannels().has(channel) ? 'var(--shikenso-pink-base)' : 'var(--shikenso-purple-base)'"
              />
            </div>
          </button>

          @if (!last) {
            <hr class="border-shikenso-purple-base-12 m-1" />
          }
        }
      </mat-menu>
    }
  } @else {
    <div class="flex gap-2">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <ngx-skeleton-loader class="h-7" [theme]="{ width: '116px', height: '28px', 'border-radius': '100vw' }" />
      }

      <ngx-skeleton-loader class="h-7" [theme]="{ width: '42px', height: '28px', 'border-radius': '100vw' }" />
    </div>
  }
</div>
